import { motion } from "framer-motion";
import { HeartHandshake, Wind, Clock, CheckCircle2 } from "lucide-react";
import { IMAGES } from "@/data";

const points = [
  { icon: HeartHandshake, text: "Judgement-free, compassionate dentists" },
  { icon: Wind, text: "Happy gas & sedation options available" },
  { icon: Clock, text: "We move at your pace — no rushing" },
];

export default function Anxiety() {
  return (
    <section id="about" data-testid="anxiety-section" className="py-24 md:py-32 bg-pd-bg">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <div className="rounded-[2rem] overflow-hidden shadow-2xl shadow-pd-forest/10">
            <img src={IMAGES.calmPatient} alt="Calm, relaxed dental patient" className="w-full h-[480px] object-cover" />
          </div>
          <div className="absolute -bottom-8 -right-4 sm:right-6 bg-white/70 backdrop-blur-xl border border-white/50 shadow-[0_8px_32px_rgba(44,64,46,0.12)] rounded-3xl p-6 max-w-[230px]">
            <div className="font-display text-5xl text-pd-accent leading-none">98%</div>
            <p className="mt-2 text-sm text-pd-body">of nervous patients say they felt at ease on their first visit.</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-xs uppercase tracking-[0.25em] font-medium text-pd-sage">Anxiety-Free Dentistry</span>
          <h2 className="mt-4 font-display text-4xl lg:text-5xl font-medium leading-tight text-pd-forest">
            Dental anxiety is normal. <br />
            <span className="italic text-pd-accent">Dreading the dentist</span> shouldn't be.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-pd-body">
            If the thought of a dental visit makes your heart race, you're not alone — and
            you're in the right place. For over a decade we've built our practice around
            gentle, unhurried care that puts you completely in control.
          </p>
          <div className="mt-8 space-y-4">
            {points.map((p) => (
              <div key={p.text} className="flex items-center gap-4">
                <span className="w-11 h-11 rounded-full bg-pd-surface flex items-center justify-center shrink-0">
                  <p.icon size={20} className="text-pd-accent" />
                </span>
                <span className="text-pd-body font-medium">{p.text}</span>
              </div>
            ))}
          </div>
          <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-2">
            {["Same-day emergencies", "Interest-free payment plans"].map((t) => (
              <span key={t} className="flex items-center gap-2 text-sm text-pd-muted">
                <CheckCircle2 size={16} className="text-pd-sage" /> {t}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
